import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { usersService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useResetPasswordFAMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({ id }: { id?: string | number }) => {
			return usersService.resetUserPassword({
				userId: id,
			});
		},
		{
			onSuccess() {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Success. Reset Password email is sent.",
					}),
				);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useResetPasswordFAMutation;
